import update from 'immutability-helper';
import React, { useEffect, useState } from 'react';
import { IPatient } from '../../../../models/prosites';
import TextInput from '../../../inputs/text-input';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    getDeviceScanOnFile,
    uploadDigitalImpressions,
} from '../../../../api/product-api';
import {
    IDeviceScanOnFile,
    sides,
    IOrderDetails,
} from '../../../../models/product-detail';
import {
    CA,
    DE,
    CartItemTypes,
    findIcon,
    MIRACLEEAR_US_SITE,
    USE_DIGITAL_IMPRESSIONS_ON_FILE,
    IMPRESSIONS_OPTIONS,
} from '../../../common/constants';
import ToolTipAnchor from '../../../common/tooltip';
import { FormattedMessage, useIntl } from 'react-intl';
import AttachImpression from './attach-impression';
import { ProductOrderFormErrors } from '../validation';
const device: IDeviceScanOnFile = {} as any;

interface Props {
    orderDetails: IOrderDetails;
    country: string;
    updatePatient: (patientDetails: IPatient) => void;
    onChange: (e: React.ChangeEvent<any>) => void;
    siteNumber?: number;
    errors: ProductOrderFormErrors;
}

const ImpressionsSection: React.FC<Props> = ({
    orderDetails,
    updatePatient,
    onChange,
    country,
    siteNumber,
    errors,
}) => {
    const intl = useIntl();
    const { impressions, patient, side } = orderDetails;
    const [scanOnFileRight, setScanOnFileRight] = useState<IDeviceScanOnFile>({
        ...device!,
        serialNumber: '',
        valid: true,
    });
    const [scanOnFileLeft, setScanOnFileLeft] = useState<IDeviceScanOnFile>({
        ...device!,
        serialNumber: '',
        valid: true,
    });
    const [lookupMessage, setlookupMessage] = useState<{
        right: boolean;
        left: boolean;
    }>({ right: false, left: false });

    const [impressionOptions] = useState(
        country === CA &&
            orderDetails.cartItemTypeId === CartItemTypes.CustomOnly
            ? IMPRESSIONS_OPTIONS
            : country === CA
            ? IMPRESSIONS_OPTIONS.slice(0, 3)
            : country === DE
            ? [IMPRESSIONS_OPTIONS[3], ...IMPRESSIONS_OPTIONS.slice(0, 2)]
            : orderDetails.cartItemTypeId === CartItemTypes.SoundGearCustom ||
              orderDetails.cartItemTypeId === CartItemTypes.SoundGearEarmold
            ? [...IMPRESSIONS_OPTIONS.slice(0, 2), IMPRESSIONS_OPTIONS[3]]
            : IMPRESSIONS_OPTIONS
    );

    let counter = 0;
    const lowerImpressionOptions = impressionOptions.map((option) =>
        option.defaultMessage.toLowerCase()
    );
    let lowerImpressions: string;
    if (impressions) {
        lowerImpressions = impressions.toLowerCase();
    }
    const validateScanOnfile = async (side: sides, serialNumber?: string) => {
        switch (side) {
            case sides.right:
                setlookupMessage({ ...lookupMessage!, right: true });
                if (
                    (serialNumber && serialNumber !== '') ||
                    (scanOnFileRight!.serialNumber &&
                        scanOnFileRight!.serialNumber !== '')
                ) {
                    if (serialNumber)
                        setScanOnFileRight((prevState) => ({
                            ...prevState!,
                            serialNumber: serialNumber,
                        }));
                    const rightFileData = (
                        await getDeviceScanOnFile(
                            serialNumber
                                ? serialNumber
                                : scanOnFileRight!.serialNumber!
                        )
                    ).data!;
                    setScanOnFileRight((prevState) => ({
                        ...prevState!,
                        valid: rightFileData.valid,
                        side: rightFileData.side,
                        patientFirstName: rightFileData.patientFirstName,
                        patientLastName: rightFileData.patientLastName,
                        otherSide: rightFileData.otherSide,
                        isBadQuality: rightFileData.isBadQuality,
                    }));
                } else {
                    setScanOnFileRight((prevState) => ({
                        ...prevState!,
                        valid: true,
                        side: undefined,
                        patientFirstName: undefined,
                        patientLastName: undefined,
                        otherSide: undefined,
                        isBadQuality: undefined,
                    }));
                }

                setlookupMessage({ ...lookupMessage!, right: false });
                break;

            case sides.left:
                setlookupMessage({ ...lookupMessage!, left: true });
                if (
                    (serialNumber && serialNumber !== '') ||
                    (scanOnFileLeft!.serialNumber &&
                        scanOnFileLeft!.serialNumber !== '')
                ) {
                    if (serialNumber)
                        setScanOnFileLeft((prevState) => ({
                            ...prevState!,
                            serialNumber: serialNumber,
                        }));
                    const leftFileData = (
                        await getDeviceScanOnFile(
                            serialNumber
                                ? serialNumber
                                : scanOnFileLeft!.serialNumber!
                        )
                    ).data!;
                    setScanOnFileLeft((prevState) => ({
                        ...prevState!,
                        valid: leftFileData.valid,
                        side: leftFileData.side,
                        patientFirstName: leftFileData.patientFirstName,
                        patientLastName: leftFileData.patientLastName,
                        serialNumber: serialNumber
                            ? serialNumber
                            : prevState!.serialNumber,
                        otherSide: leftFileData.otherSide,
                        isBadQuality: leftFileData.isBadQuality,
                    }));
                } else {
                    setScanOnFileLeft((prevState) => ({
                        ...prevState!,
                        valid: true,
                        side: undefined,
                        patientFirstName: undefined,
                        patientLastName: undefined,
                        otherSide: undefined,
                        isBadQuality: undefined,
                    }));
                }
                setlookupMessage({ ...lookupMessage!, left: false });
                break;
        }
    };

    // TODO: replace with spread operator and feed to parent component.
    const updatePatientData = (event: any) => {
        switch (event.target.name) {
            case 'DirectEarScanRight':
                updatePatient(
                    update(patient!, {
                        otoscanPackageId1: {
                            $set:
                                event.target.value !== ''
                                    ? event.target.value
                                    : null,
                        },
                    })
                );
                break;
            case 'DirectEarScanLeft':
                updatePatient(
                    update(patient!, {
                        otoscanPackageId2: {
                            $set:
                                event.target.value !== ''
                                    ? event.target.value
                                    : null,
                        },
                    })
                );
                break;
        }
    };

    const fileupload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, parentElement } = e.target;

        const formdata = new FormData(parentElement as HTMLFormElement);

        e.persist();
        e.preventDefault();
        setlookupMessage(
            name === 'rightImpression'
                ? { ...lookupMessage, right: true }
                : { ...lookupMessage, left: true }
        );
        const blob = await uploadDigitalImpressions(formdata);
        setlookupMessage(
            name === 'rightImpression'
                ? { ...lookupMessage, right: false }
                : { ...lookupMessage, left: false }
        );

        updatePatient(
            name === 'rightImpression'
                ? update(patient!, {
                      impressionRight: { $set: blob.data! },
                      rightImpressionFileName: {
                          $set: e.target.files![0].name,
                      },
                  })
                : update(patient!, {
                      impressionLeft: { $set: blob.data! },
                      leftImpressionFileName: { $set: e.target.files![0].name },
                  })
        );
    };

    useEffect(() => {
        updatePatient(
            update(patient!, {
                scanOnFileRight: {
                    $set:
                        scanOnFileRight!.valid && scanOnFileRight!.side === 'R'
                            ? scanOnFileRight!.serialNumber
                            : null,
                },
                scanOnFileLeft: {
                    $set:
                        scanOnFileLeft!.valid && scanOnFileLeft!.side === 'L'
                            ? scanOnFileLeft!.serialNumber
                            : null,
                },
            })
        );
    }, [scanOnFileLeft, scanOnFileRight]);

    useEffect(() => {
        if (impressions !== USE_DIGITAL_IMPRESSIONS_ON_FILE) {
            setScanOnFileRight((prevState) => ({
                ...prevState!,
                valid: true,
                side: undefined,
                patientFirstName: undefined,
                patientLastName: undefined,
                otherSide: undefined,
                isBadQuality: undefined,
                serialNumber: '',
            }));
            setScanOnFileLeft((prevState) => ({
                ...prevState!,
                valid: true,
                side: undefined,
                patientFirstName: undefined,
                patientLastName: undefined,
                otherSide: undefined,
                isBadQuality: undefined,
                serialNumber: '',
            }));
        }
    }, [impressions]);

    return (
        <div className="col-md-12">
            {impressionOptions.map((option) => {
                return (
                    <div className="col-md-12" key={option.id}>
                        <input
                            type="radio"
                            name="impressions"
                            id={option.id}
                            value={option.defaultMessage}
                            checked={
                                lowerImpressions ===
                                lowerImpressionOptions[counter++] // what in god's name is this?
                            }
                            onChange={onChange}
                        />
                        <span>&nbsp;&nbsp;</span>
                        {intl.formatMessage(option)}
                        {option.defaultMessage ===
                            'Use digital impressions on file' && (
                            <ToolTipAnchor
                                toolTipMessage={`<div>
                                <p>${intl.formatMessage({
                                    id: 'Using_a_digital_impression_eli',
                                    defaultMessage:
                                        'Using a digital impression eliminates the need to fax or physically send your order to us.',
                                })}</p>
                                <p>
                                    <span>${intl.formatMessage({
                                        id: 'New_Order_Impressions_Message_PART_1',
                                        defaultMessage: 'This is considered a',
                                    })} </span>
                                    <strong>${intl.formatMessage({
                                        id: 'New_Order_Impressions_Message_PART_2',
                                        defaultMessage: 'New Order',
                                    })}</strong>
                                    <span>${intl.formatMessage({
                                        id: 'New_Order_Impressions_Message_PART_3',
                                        defaultMessage:
                                            'so it is essential to select the desired Style, Technology Level, and any other options for your order.',
                                    })}</span>
                                    <span>${intl.formatMessage({
                                        id: 'New_Order_Impressions_Message_PART_4',
                                        defaultMessage:
                                            'Digital impressions can be used in lieu of new impressions and are only recommended if there are no previous fit issues.',
                                    })}</span>
                                </p>
                            </div>`}
                            />
                        )}
                        {option.defaultMessage ===
                            'Attach digital impressions' &&
                            siteNumber === MIRACLEEAR_US_SITE && (
                                <ToolTipAnchor
                                    toolTipMessage={intl.formatMessage({
                                        id: 'Refer_to_MLS_ME',
                                        defaultMessage:
                                            'Refer to LMS Miracle-EarPro iScan Process for detailed instructions',
                                    })}
                                />
                            )}

                        {impressions === 'Use digital impressions on file' &&
                            option.defaultMessage ===
                                'Use digital impressions on file' && (
                                <div>
                                    <p className="col-sm-12">
                                        {intl.formatMessage({
                                            id: 'New_Order_Impressions_Message_PART_1',
                                            defaultMessage:
                                                'This is considered a',
                                        })}{' '}
                                        <strong>
                                            {intl.formatMessage({
                                                id: 'New_Order_Impressions_Message_PART_2',
                                                defaultMessage: 'New Order',
                                            })}
                                        </strong>{' '}
                                        {intl.formatMessage({
                                            id: 'New_Order_Impressions_Message_PART_3',
                                            defaultMessage:
                                                'so it is essential to select the desired Style, Technology Level, and any other options for your order.',
                                        })}
                                    </p>
                                    <p className="col-sm-12">
                                        {intl.formatMessage({
                                            id: 'Please_enter_the_reference_ser',
                                            defaultMessage: `Please enter the reference serial
                                        number(s).`,
                                        })}{' '}
                                        <strong>
                                            {intl.formatMessage({
                                                id: 'Please_call_2012_prior',
                                                defaultMessage: `Please call customer service to
                                            verify scan on file if referencing a
                                            scan prior to 2012.`,
                                            })}
                                        </strong>
                                    </p>
                                    {(side === 'B' || side === 'R') && (
                                        <>
                                            <div className="col-sm-12">
                                                <div
                                                    className="col-sm-1"
                                                    style={{
                                                        marginTop: '25px',
                                                    }}
                                                >
                                                    <i
                                                        className="fal fa-ear"
                                                        style={{
                                                            color: 'red',
                                                            fontSize: '25px',
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className="col-sm-11"
                                                    style={{
                                                        marginLeft: '-60px',
                                                    }}
                                                >
                                                    <TextInput
                                                        label={'Right Serial #'}
                                                        name={'ScanOnFileRight'}
                                                        value={
                                                            scanOnFileRight!
                                                                .serialNumber
                                                        }
                                                        labelClassName="col-sm-12"
                                                        fieldClassName="col-sm-3"
                                                        onChange={(e) => {
                                                            e.target.value =
                                                                e.target.value
                                                                    .trim()
                                                                    .toUpperCase();
                                                            e.persist();
                                                            setScanOnFileRight(
                                                                (
                                                                    prevState
                                                                ) => ({
                                                                    ...prevState!,
                                                                    serialNumber:
                                                                        e.target
                                                                            .value,
                                                                })
                                                            );
                                                        }}
                                                        onBlur={() =>
                                                            validateScanOnfile(
                                                                sides.right
                                                            )
                                                        }
                                                        error={
                                                            errors.scanOnFileRight
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                className="col-sm-12"
                                                style={{ marginLeft: '60px' }}
                                            >
                                                {lookupMessage!.right && (
                                                    <p>
                                                        {intl.formatMessage({
                                                            id: 'Looking_Up',
                                                            defaultMessage:
                                                                'Looking Up',
                                                        })}
                                                        ...
                                                    </p>
                                                )}
                                                {scanOnFileRight &&
                                                    (scanOnFileRight!.valid &&
                                                    scanOnFileRight!.side ===
                                                        'R' ? (
                                                        <>
                                                            <p
                                                                className={
                                                                    'font-green'
                                                                }
                                                            >
                                                                {' '}
                                                                <FontAwesomeIcon
                                                                    icon={findIcon(
                                                                        'fad',
                                                                        'check'
                                                                    )}
                                                                />{' '}
                                                                {`${intl.formatMessage(
                                                                    {
                                                                        id: 'Patient_Name',
                                                                        defaultMessage:
                                                                            'Patient Name',
                                                                    }
                                                                )}: ${
                                                                    scanOnFileRight!
                                                                        .patientFirstName
                                                                } ${
                                                                    scanOnFileRight!
                                                                        .patientLastName
                                                                }`}
                                                            </p>
                                                            {scanOnFileRight.otherSide &&
                                                                !patient!
                                                                    .scanOnFileLeft &&
                                                                side ===
                                                                    'B' && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn-link"
                                                                        onClick={() =>
                                                                            validateScanOnfile(
                                                                                sides.left,
                                                                                scanOnFileRight.otherSide
                                                                            )
                                                                        }
                                                                    >
                                                                        <FormattedMessage
                                                                            id={
                                                                                'Click_here_to_include_other_si'
                                                                            }
                                                                            defaultMessage={`Click here to include other side (${scanOnFileRight.otherSide})`}
                                                                            values={{
                                                                                0: scanOnFileRight.otherSide,
                                                                            }}
                                                                        />
                                                                    </button>
                                                                )}
                                                        </>
                                                    ) : scanOnFileRight!
                                                          .isBadQuality ? (
                                                        <>
                                                            <p className="font-error">
                                                                <FormattedMessage
                                                                    id={
                                                                        'New_Impression_Required'
                                                                    }
                                                                    defaultMessage={`
                                                                Due to the
                                                                quality of the
                                                                impression on
                                                                file, a new
                                                                impression is
                                                                required.`}
                                                                />
                                                            </p>
                                                        </>
                                                    ) : !scanOnFileRight!
                                                          .valid ? (
                                                        <>
                                                            <p className="font-error">
                                                                {intl.formatMessage(
                                                                    {
                                                                        id: 'Invalid_serial_number',
                                                                        defaultMessage:
                                                                            'Invalid serial number',
                                                                    }
                                                                )}
                                                            </p>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {scanOnFileRight!
                                                                .side &&
                                                                scanOnFileRight!
                                                                    .side !==
                                                                    'R' && (
                                                                    <p className="font-error">
                                                                        {intl.formatMessage(
                                                                            {
                                                                                id: 'wrong_side',
                                                                                defaultMessage:
                                                                                    'wrong side',
                                                                            }
                                                                        )}
                                                                    </p>
                                                                )}
                                                        </>
                                                    ))}
                                            </div>
                                        </>
                                    )}
                                    {(side === 'B' || side === 'L') && (
                                        <>
                                            <div className="col-sm-12">
                                                <div
                                                    className="col-sm-1"
                                                    style={{
                                                        marginTop: '25px',
                                                    }}
                                                >
                                                    <i
                                                        className="fal fa-ear"
                                                        style={{
                                                            color: 'blue',
                                                            fontSize: '25px',
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className="col-sm-11"
                                                    style={{
                                                        marginLeft: '-60px',
                                                    }}
                                                >
                                                    <TextInput
                                                        label={'Left Serial #'}
                                                        name={'ScanOnFileLeft'}
                                                        value={
                                                            scanOnFileLeft!
                                                                .serialNumber
                                                        }
                                                        labelClassName="col-sm-12"
                                                        fieldClassName="col-sm-3"
                                                        onChange={(e) => {
                                                            e.target.value =
                                                                e.target.value
                                                                    .trim()
                                                                    .toUpperCase();
                                                            e.persist();
                                                            setScanOnFileLeft(
                                                                (
                                                                    prevState
                                                                ) => ({
                                                                    ...prevState!,
                                                                    serialNumber:
                                                                        e.target
                                                                            .value,
                                                                })
                                                            );
                                                        }}
                                                        onBlur={() =>
                                                            validateScanOnfile(
                                                                sides.left
                                                            )
                                                        }
                                                        error={
                                                            errors.scanOnFileLeft
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                className="col-sm-12"
                                                style={{ marginLeft: '60px' }}
                                            >
                                                {lookupMessage!.left && (
                                                    <p>
                                                        {intl.formatMessage({
                                                            id: 'Looking_Up',
                                                            defaultMessage:
                                                                'Looking Up',
                                                        })}
                                                        ....
                                                    </p>
                                                )}
                                                {scanOnFileLeft &&
                                                    (scanOnFileLeft!.valid &&
                                                    scanOnFileLeft!.side ===
                                                        'L' ? (
                                                        <>
                                                            <p
                                                                className={
                                                                    'font-green'
                                                                }
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={findIcon(
                                                                        'fad',
                                                                        'check'
                                                                    )}
                                                                />{' '}
                                                                {`${intl.formatMessage(
                                                                    {
                                                                        id: 'Patient_Name',
                                                                        defaultMessage:
                                                                            'Patient Name',
                                                                    }
                                                                )}:  ${
                                                                    scanOnFileLeft!
                                                                        .patientFirstName
                                                                } ${
                                                                    scanOnFileLeft!
                                                                        .patientLastName
                                                                }`}
                                                            </p>
                                                            {scanOnFileLeft.otherSide &&
                                                                !patient!
                                                                    .scanOnFileRight &&
                                                                side ===
                                                                    'B' && (
                                                                    <button
                                                                        className="btn-link"
                                                                        type="button"
                                                                        onClick={() =>
                                                                            validateScanOnfile(
                                                                                sides.right,
                                                                                scanOnFileLeft.otherSide
                                                                            )
                                                                        }
                                                                    >
                                                                        <FormattedMessage
                                                                            id={
                                                                                'Click_here_to_include_other_si'
                                                                            }
                                                                            defaultMessage={`Click here to include other side (${scanOnFileLeft.otherSide})`}
                                                                            values={{
                                                                                0: scanOnFileLeft.otherSide,
                                                                            }}
                                                                        />
                                                                    </button>
                                                                )}
                                                        </>
                                                    ) : scanOnFileLeft!
                                                          .isBadQuality ? (
                                                        <>
                                                            <p className="font-error">
                                                                <FormattedMessage
                                                                    id={
                                                                        'New_Impression_Required'
                                                                    }
                                                                    defaultMessage={`
                                                                Due to the
                                                                quality of the
                                                                impression on
                                                                file, a new
                                                                impression is
                                                                required.`}
                                                                />
                                                            </p>
                                                        </>
                                                    ) : !scanOnFileLeft!
                                                          .valid ? (
                                                        <>
                                                            <p className="font-error">
                                                                {intl.formatMessage(
                                                                    {
                                                                        id: 'Invalid_serial_number',
                                                                        defaultMessage:
                                                                            'Invalid serial number',
                                                                    }
                                                                )}
                                                            </p>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {scanOnFileLeft!
                                                                .side &&
                                                                scanOnFileLeft!
                                                                    .side !==
                                                                    'L' && (
                                                                    <p className="font-error">
                                                                        {intl.formatMessage(
                                                                            {
                                                                                id: 'wrong_side',
                                                                                defaultMessage:
                                                                                    'wrong side',
                                                                            }
                                                                        )}
                                                                    </p>
                                                                )}
                                                        </>
                                                    ))}
                                            </div>
                                        </>
                                    )}
                                </div>
                            )}
                        {impressions === 'Direct ear scan' &&
                            option.defaultMessage === 'Direct ear scan' && (
                                <div>
                                    {(side === 'B' || side === 'R') && (
                                        <>
                                            <TextInput
                                                label={'Right Package ID'}
                                                name={'DirectEarScanRight'}
                                                value={
                                                    patient!.otoscanPackageId1!
                                                }
                                                labelClassName="col-sm-12"
                                                fieldClassName="col-sm-3"
                                                onChange={updatePatientData}
                                                error={errors.otoscanPackageId1}
                                            />
                                        </>
                                    )}
                                    {(side === 'B' || side === 'L') && (
                                        <>
                                            <TextInput
                                                label={'Left Package ID'}
                                                name={'DirectEarScanLeft'}
                                                value={
                                                    patient!.otoscanPackageId2!
                                                }
                                                labelClassName="col-sm-12"
                                                fieldClassName="col-sm-3"
                                                onChange={updatePatientData}
                                                error={errors.otoscanPackageId2}
                                            />
                                        </>
                                    )}
                                </div>
                            )}
                        {impressions === 'Attach digital impressions' &&
                            option.defaultMessage ===
                                'Attach digital impressions' && (
                                <div>
                                    <AttachImpression
                                        side={side!}
                                        attachmentSide="R"
                                        patient={patient}
                                        fileupload={fileupload}
                                        updatePatient={updatePatient}
                                        update={update}
                                        lookupMessage={lookupMessage}
                                        error={errors.impressionRight}
                                    />
                                    <AttachImpression
                                        side={side!}
                                        attachmentSide="L"
                                        patient={patient}
                                        fileupload={fileupload}
                                        updatePatient={updatePatient}
                                        update={update}
                                        lookupMessage={lookupMessage}
                                        error={errors.impressionLeft}
                                    />
                                </div>
                            )}
                    </div>
                );
            })}
        </div>
    );
};

export default ImpressionsSection;
